import { icon } from '../../icons';
import { type PropertyDto } from '../../services/api';
import { t } from '../../services/i18n';
import { esc } from './onboarding-shared';

export class RcOnboardingStepProperty extends HTMLElement {
  createdProperty: PropertyDto | null = null;
  csvImportNotice: string | null = null;
  csvImportErrors: string[] = [];
  isImportingCsv = false;

  render(): void {
    const existing = this.createdProperty;
    const selected = (value: string) => existing?.type === value ? 'selected' : '';
    this.innerHTML = `
      <div class="wizard-step-content">
        <h1 class="wizard-step-title">${t('onboarding.property.title')}</h1>
        <p class="wizard-step-desc">${t('onboarding.property.description')}</p>
        <div class="wizard-import-card">
          <div class="profile-section-head">
            <h2>${t('onboarding.csvTitle')}</h2>
            <p>${t('onboarding.csvDescription')}</p>
          </div>
          <div class="wizard-import-actions">
            <a class="btn btn-outline" href="/assets/template.csv" download>${t('onboarding.csvTemplateLink')}</a>
            <label class="btn btn-outline wizard-import-file-btn" for="w-csv-file">${t('onboarding.csvFileLabel')}</label>
            <input id="w-csv-file" name="csvFile" type="file" accept=".csv,text/csv" class="file-input-hidden">
            <button type="button" class="btn btn-primary" id="wizard-import-csv" ${this.isImportingCsv ? 'disabled' : ''}>${t('onboarding.csvImportButton')}</button>
          </div>
          <p class="wizard-import-hint">${t('onboarding.csvHint')}</p>
          ${this.csvImportNotice ? `<div class="wizard-import-feedback wizard-import-feedback--success">${esc(this.csvImportNotice)}</div>` : ''}
          ${this.csvImportErrors.length > 0 ? `<div class="wizard-import-feedback wizard-import-feedback--error">${this.csvImportErrors.map((error) => `<div>${esc(error)}</div>`).join('')}</div>` : ''}
        </div>
        <form id="wizard-form" class="wizard-form" novalidate>
          <div class="form-group">
            <label for="w-address">${t('common.address')} <span class="required">*</span></label>
            <input id="w-address" name="address" type="text" required placeholder="${t('property.addressPlaceholder')}" autocomplete="street-address" value="${existing ? esc(existing.address) : ''}">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="w-type">${t('onboarding.property.typeLabel')} <span class="required">*</span></label>
              <select id="w-type" name="type" required>
                <option value="Appartement" ${selected('Appartement')}>${t('property.type.apartment')}</option>
                <option value="Huis" ${selected('Huis')}>${t('property.type.house')}</option>
                <option value="Studio" ${selected('Studio')}>${t('property.type.studio')}</option>
                <option value="Commercieel" ${selected('Commercieel')}>${t('property.type.commercial')}</option>
                <option value="Garage" ${selected('Garage')}>${t('property.type.garage')}</option>
                <option value="Ander" ${selected('Ander')}>${t('property.type.other')}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label for="w-desc">${t('common.description')} <span class="optional">${t('common.optional')}</span></label>
            <textarea id="w-desc" name="description" rows="2" placeholder="${t('property.descriptionPlaceholder')}">${existing?.description ? esc(existing.description) : ''}</textarea>
          </div>
          <div id="wizard-error" class="wizard-error" style="display:none"></div>
          <div class="wizard-actions">
            <button type="button" class="btn btn-outline wizard-prev-btn">
              ${icon('arrow-left', { size: 16, strokeWidth: 2.5 })}
              ${t('common.previous')}
            </button>
            <button type="submit" class="btn btn-primary btn-lg wizard-next-btn">
              ${t('onboarding.property.next')}
              ${icon('arrow-right', { size: 16, strokeWidth: 2.5 })}
            </button>
          </div>
        </form>
      </div>
    `;

    this.querySelector('.wizard-prev-btn')?.addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent('onboarding-prev', { bubbles: true }));
    });
    this.querySelector<HTMLButtonElement>('#wizard-import-csv')?.addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent('onboarding-csv-import', { bubbles: true }));
    });
    this.querySelector<HTMLFormElement>('#wizard-form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.dispatchEvent(new CustomEvent('onboarding-submit', {
        bubbles: true,
        detail: { form: event.currentTarget as HTMLFormElement },
      }));
    });
  }
}

if (!customElements.get('rc-onboarding-step-property')) {
  customElements.define('rc-onboarding-step-property', RcOnboardingStepProperty);
}
